module.exports = __webpack_public_path__ + "static/media/udemy.4254490f.png";